import React, { useEffect } from 'react'

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared'

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions'
import { GettyStore } from 'domains/org/getty/store'

import { Confirm } from 'components/ui/modal'
import { StatusGuard } from 'components/ui/status-guard'

import { pick } from 'helpers/core'
import { Status } from 'helpers/status'

import { Amenity } from 'generated/mos/org/getty/visitorinfo'
import { DeleteAmenityRequest }  from 'generated/mos/org/getty/visitorinfomanagement'

import { amenitySchema } from '../../../schemas/visitorInfo'


type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteAmenityRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'amenityDelete'>;

type DirectProps = {
  readonly amenity: Amenity.Entity;
  readonly onCancel: () => void;
  readonly onComplete? : () => void;
}

type Props = ActionProps & ConnectedProps & DirectProps;

const AmenityDeleteView = (props: Props) => {
  const {
    gettyDeleteAmenityRequest,
    toastNotification,
    amenityDelete,
    onCancel,
    amenity,
    onComplete,
  } = props

  const message = <>
    <p>Are you sure you want to permanently delete</p>
    <p>"{amenitySchema.name.read(amenity.name)}"?</p>
  </>

  const onConfirmDelete = () => {
    amenity.ref && gettyDeleteAmenityRequest({
      ...DeleteAmenityRequest.defaults,
      amenityRef: amenity.ref,
    })
    onCancel()
    onComplete && onComplete()
  }

  useEffect(() => {
    amenityDelete.status === Status.Failed &&
      toastNotification({
        type: 'error',
        text: 'Could not delete the amenity',
      });
  }, [amenityDelete.status, toastNotification])

  return (
    <StatusGuard status={amenityDelete}>
      <Confirm
        title="Delete Amenity Page?"
        onClose={onCancel}
        message={message}
        confirmLabel="Delete"
        onConfirm={onConfirmDelete}
        danger
      />
    </StatusGuard>
  );
};

export const AmenityDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'amenityDelete'),
  {
    ...pick(actionCreators, 'gettyDeleteAmenityRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(AmenityDeleteView)
